const API_BASE = '/api';

async function fetchJSON(url, options) {
  const res = await fetch(url, options);
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
}

export async function fetchDesigns() {
  const data = await fetchJSON(`${API_BASE}/GetDesigns`);
  return data.items || [];
}

export async function saveDesignToServer(design) {
  return fetchJSON(`${API_BASE}/SaveDesign`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(design),
  });
}

export async function deleteDesignFromServer(id) {
  const res = await fetch(`${API_BASE}/DeleteDesign?id=${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
  if (!res.ok) throw new Error(`Delete failed: ${res.status}`);
}

export async function updateDesignOnServer(design) {
  return fetchJSON(`${API_BASE}/SaveDesign`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(design),
  });
}
